import React from 'react'
import { TextField } from '@mui/material';

export default function Input(props) {
    const { name, label, sx, value = "", error = null, onChange, disabled,required, ...rest } = props;
    return (
        <>
            <TextField
                variant="outlined"
                label={label}
                placeholder={
                    !label && required ? "Field is required *" : undefined
                }
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                required={required}
                {...rest}
                fullWidth
                {...(error && { error: true, helperText: error })}
                sx={{
                    ...sx,
                    "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "red !important",
                    },
                    "& .MuiFormHelperText-root.Mui-error": {
                        color: "red !important",
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#1e293b !important",
                        color: "#1e293b !important",
                        opacity: 1,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#1e293b !important",
                        opacity: 1,
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#cbd5e1 !important",
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: "#f8fafc",
                        cursor: "not-allowed",
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: "14px",
                        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                        "&.Mui-disabled": {
                            color: "#1e293b !important",
                            opacity: 1,
                        },
                    },
                    "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                }}
                InputProps={{
                    sx: {
                        backgroundColor: disabled ? "#f8fafc" : (!value ? "#f8fafc" : "#ffffff"),
                        "&.Mui-disabled": {
                            backgroundColor: "#f8fafc",
                            cursor: "not-allowed",
                        },
                    }
                }}
            />

        </>
    )
}
